import { render } from "./AlumnosView.vue?vue&type=template&id=6e71ab38"
import script from "./AlumnosView.vue?vue&type=script&lang=js"
export * from "./AlumnosView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__